module.exports = __webpack_public_path__ + "static/img/result3.6467b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/result3.png
// module id = 06RH
// module chunks = 1